/**
=========================================================
* Trust Cargo - table cells
=========================================================
*/

// Soft UI Dashboard React base styles
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

// Soft UI Dashboard React helper functions
import pxToRem from "assets/theme/functions/pxToRem";
import rgba from "assets/theme/functions/rgba";

const { borderWidth } = borders;
const { dark, text, grey } = colors;
const { size, fontWeightRegular } = typography;

const tableCell = {
  styleOverrides: {
    root: {
      // Roomier than the stock 12/16. Dense rows are the main reason long
      // lists feel like work to read.
      padding: `${pxToRem(16)} ${pxToRem(20)}`,
      // Hairline instead of a solid rule - the eye still gets the row
      // boundary without the grid shouting over the data.
      borderBottom: `${borderWidth[1]} solid ${rgba(dark.main, 0.07)}`,
      fontSize: size.sm,
      fontWeight: fontWeightRegular,
      color: text.focus,
      verticalAlign: "middle",
      // Digits line up in columns, so amounts and CBM figures can be compared
      // down the column instead of being read one by one.
      fontVariantNumeric: "tabular-nums",
      transition: "background-color 180ms ease",
    },

    // the last row should not draw a line into the card's bottom edge
    body: {
      "tr:last-of-type & ": {
        borderBottom: "none",
      },
    },

    sizeSmall: {
      padding: `${pxToRem(10)} ${pxToRem(14)}`,
    },

    footer: {
      color: dark.main,
      fontWeight: typography.fontWeightBold,
      borderTop: `${borderWidth[1]} solid ${grey[300]}`,
      borderBottom: "none",
    },
  },
};

export default tableCell;
